import React from "react";

export default function Home() {

    return (<>
        <section>
            <h1>NewDay Project Stratus</h1>
            <p>
                This application exists to execute Stratus Platform Capabilities - it's not a finished application.<br />
                The operations that you see in here may not be how these features would be implemented in real client applications.<br />
            </p>
            <p>Everything you see in here is working - but this app will be used to manually trigger operations that "just happen in the background" during the normal operation of the real, running, system.<br />
            </p>
            <p>
                Not to be sold separately!
            </p>
        </section>
    </>);

}